(function () {
  'use strict';

  function initSwatchGroup(swatchGroup) {
    swatchGroup.querySelectorAll('.card-swatch').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var card = btn.closest('.card-wrapper');
        if (!card) return;

        // --- Update active swatch ---
        swatchGroup.querySelectorAll('.card-swatch').forEach(function (s) {
          s.classList.remove('card-swatch--active');
        });
        btn.classList.add('card-swatch--active');

        // --- Swap card images ---
        // Update all imgs in .card__media (primary + secondary hover) so the
        // Dawn hover-effect doesn't reveal a stale image on mouseover/mouseout
        var newSrc = btn.dataset.swatchImageSrc;
        var newAlt = btn.dataset.swatchImageAlt;
        if (newSrc) {
          card.querySelectorAll('.card__media img').forEach(function (img) {
            img.src = newSrc;
            img.srcset = newSrc;
            if (newAlt) img.alt = newAlt;
          });
        }

        // --- Update card title ---
        if (btn.dataset.swatchProductTitle) {
          var titleLink = card.querySelector('[id^="CardLink-"]');
          if (titleLink) titleLink.textContent = btn.dataset.swatchProductTitle;

          var noMediaLink = card.querySelector('[id^="StandardCardNoMediaLink-"]');
          if (noMediaLink) noMediaLink.textContent = btn.dataset.swatchProductTitle;
        }

        // --- Update all product links within the card ---
        var productUrl = btn.dataset.swatchProductUrl;
        if (productUrl) {
          card.querySelectorAll('a[href]').forEach(function (a) {
            if (a.getAttribute('href').startsWith('/products/')) {
              a.href = productUrl;
            }
          });
        }
      });
    });
  }

  function initAll(root) {
    root.querySelectorAll('[data-card-swatches]').forEach(initSwatchGroup);
  }

  // Run immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Handle dynamically injected cards (infinite scroll, pagination)
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.hasAttribute('data-card-swatches')) {
            initSwatchGroup(node);
          } else if (node.querySelector) {
            node.querySelectorAll('[data-card-swatches]').forEach(initSwatchGroup);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
